import { motion, useReducedMotion } from 'motion/react';
import { EASE_MK } from '@/Components/Marketing/easing';

/**
 * Fades its content up once, the first time a fifth of it scrolls into view.
 * `as` is the HTML tag to render (div by default); `delay` staggers siblings,
 * in seconds. With reduced motion on it renders the plain element: no initial
 * offset, no animation.
 */
export default function Reveal({ as = 'div', delay = 0, className, children, ...props }) {
    const reduceMotion = useReducedMotion();

    if (reduceMotion) {
        const Tag = as;

        return (
            <Tag className={className} {...props}>
                {children}
            </Tag>
        );
    }

    const MotionTag = motion[as];

    return (
        <MotionTag
            className={className}
            {...props}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.8, ease: EASE_MK, delay }}
        >
            {children}
        </MotionTag>
    );
}
